/*
    filter 邏輯
    1. init(is_first=true) =>
        1. query_to_filter
        2. fetch_core_waybills
            1. filter_to_api_query
            2. axios
        if (is_first) {
            3. handle_quick_filter_key ui 決定要顯示哪個filter 樣式
        }
    2. filter() =>
        1. filter_to_query
        2. routes.push() 觸發 watch_routes()

    3. watch_routes() =>
        1. init(false)
 */
import moment from "moment"
import ResponseError from '@javascripts/response_error.js'

const store = {
    namespaced: true,
    state: {
        operations: [],
        pagination: {
            current_page: null,
            total_pages: null,
        },
        filter: {
            is_advanced_mode: false,
            shortcut_keys: [
                "number", "customer_note",
                "original_file_name", "is_done",
                "created_duration"
            ],
            current_shortcut_key: "number",
            init_columns: {
                page: 1,
                created_duration: "",
                begin_at: null,
                end_at: null,
                number: null,
                customer_note: null,
                original_file_name: null,
                is_done: false,
            },
            columns: {}
        },
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let columns = _.cloneDeep(state.filter.columns)
            if (columns.page) delete columns.page
            if (!columns.is_done) delete columns.is_done
            if (columns.created_duration) {
                if (columns.created_duration[0]) columns.begin_at = moment(columns.created_duration[0]).format("YYYY-MM-DD")
                if (columns.created_duration[1]) columns.end_at = moment(columns.created_duration[1]).format("YYYY-MM-DD")
                delete columns.created_duration
            }
            return object_delete_null(columns)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload) => {
                let columns = _.cloneDeep(state.filter.columns)

                if (columns.created_duration) {
                    if (columns.created_duration[0]) columns.begin_at = date_to_start(columns.created_duration[0])
                    if (columns.created_duration[1]) columns.end_at = date_to_end(columns.created_duration[1])
                    delete columns.created_duration
                }
                return object_to_query(columns)
            }
        },
    },
    actions: {
        fetch_operations(context, payload) {
            let url = new RestUrl(context.rootState.customer.routes.api_v1_customer_operations).parse(
                {},
                ""
            )
            let api_query = context.getters.filter_to_api_query()
            if (api_query) url += `?${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_operations', response.data.operations)
                        context.commit('set_pagination', response.data.pagination)
                    } else if (response.data.status == 'failure') {
                        return Promise.reject('fetch_operations_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter.init_columns), ...payload.query}
                if (query.begin_at && query.end_at) {
                    query.created_duration = [
                        moment(query.begin_at) || "",
                        moment(query.end_at) || ""
                    ]
                    delete query.begin_at
                    delete query.end_at
                }

                if (query.is_done) query.is_done = (query.is_done == true || query.is_done == 'true')
                context.state.filter.columns = {...context.state.filter.columns, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let columns = object_delete_null(
                _.cloneDeep(context.state.filter.columns)
            )

            if (columns.page) delete columns.page
            if (!columns.is_done) delete columns.is_done
            let shortcut_key_occurrence_number = {
                number: 0,
                number_last_key: "",
            }

            context.state.filter.shortcut_keys.forEach((key) => {
                if(columns[key]) {
                    shortcut_key_occurrence_number.number += 1
                    shortcut_key_occurrence_number.number_last_key = key
                }
            })

            if (shortcut_key_occurrence_number.number == 1) {
                context.state.filter.current_shortcut_key =
                    shortcut_key_occurrence_number.number_last_key
            }

            if (
                (
                    shortcut_key_occurrence_number.number == 0 &&
                    Object.keys(columns).length >= 1
                ) || (
                    shortcut_key_occurrence_number.number >= 2
                )
            ) {
                context.state.filter.is_advanced_mode = true
            }
        },
    },
    mutations: {
        set_operations(state, payload) {
            state.operations = payload
        },
        set_pagination(state, payload) {
            state.pagination = payload
        },
        init_filter_columns(state, payload) {
            state.filter.columns = _.cloneDeep(state.filter.init_columns)
        }
    }
}

export default store
